const FAQ = [
  { q: "Les certificats E.C.S sont-ils reconnus par l'État français ?",
    a: "Non. Les certificats E.C.S sont des certifications privées de connaissances. Ils prouvent que vous avez suivi et validé un parcours d'apprentissage sérieux, mais ne constituent pas un diplôme d'État, ni une habilitation professionnelle." },
  { q: "Puis-je exercer un métier réglementé grâce à E.C.S ?",
    a: "Non. Nos certifications sont éducatives : elles vous apportent une culture solide sur un sujet, mais ne remplacent en aucun cas un diplôme d'État reconnu (médecin, infirmier, entraîneur diplômé, etc.). Les catégories Santé et Médical le rappellent explicitement." },
  { q: "Combien de tentatives ai-je pour valider un quiz ?",
    a: "Trois tentatives, puis un verrouillage de 7 jours. C'est fait exprès : pour vous protéger du bachotage à l'aveuglette et vous permettre de réviser sérieusement." },
  { q: "Que se passe-t-il si je change d'onglet pendant un quiz ?",
    a: "Le timer se met en pause et le changement est enregistré. Au-delà de 3 changements d'onglet, la tentative est signalée à notre équipe. Restez concentré(e) sur votre écran !" },
  { q: "Puis-je être remboursé(e) ?",
    a: "Oui, dans les 48 heures suivant l'achat et à condition de n'avoir ouvert aucune leçon. Après cela, l'accès étant illimité à vie, la formation est considérée comme consommée." },
  { q: "Comment fonctionne le parrainage ?",
    a: "Vous recevez 10€ de crédit à chaque fois qu'un ami parrainé achète sa première certification. Le crédit est appliqué automatiquement sur votre prochain achat." },
];

export default function Faq() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="faq-page">
      <div className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-3">Questions fréquentes</div>
      <h1 className="font-display text-4xl md:text-5xl text-ink-900">On répond aux vraies questions</h1>
      <p className="text-muted2 mt-3">Ce que la plupart des gens se demandent avant de se lancer.</p>

      <div className="space-y-3 mt-10">
        {FAQ.map((f, i) => (
          <details key={i} className="glass rounded-2xl p-5 group" data-testid={`faq-item-${i}`}>
            <summary className="cursor-pointer flex items-center justify-between gap-3 list-none">
              <span className="font-display text-lg text-ink-900">{f.q}</span>
              <span className="text-gold-700 text-2xl leading-none group-open:rotate-45 transition-transform">+</span>
            </summary>
            <p className="text-sm text-muted2 mt-3 leading-relaxed">{f.a}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
